export interface PanoramaViewportInsets { left: number; right: number; bottom: number }
export const FULL_PANORAMA_VIEWPORT: PanoramaViewportInsets = { left: 0, right: 0, bottom: 0 };

/** Use committed scene bounds, not the independently animated pane positions. */
export function panoramaViewportInsets(browserWidth: number, editorWidth: number, assetsHeight: number, rtl: boolean): PanoramaViewportInsets {
  return { left: rtl ? editorWidth : browserWidth, right: rtl ? browserWidth : editorWidth, bottom: assetsHeight };
}

/** Resize the projection only. Never reset heading, position or the user's zoom. */
export function observePanoramaViewport(container: HTMLElement, camera: {
  aspect: number; updateProjectionMatrix: () => void;
}, renderer: { setSize: (width: number, height: number) => void }) {
  let previous = '';
  const resize = () => {
    const width = container.clientWidth, height = container.clientHeight;
    if (!width || !height || previous === `${width}:${height}`) return;
    previous = `${width}:${height}`;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
  };
  const observer = new ResizeObserver(resize);
  observer.observe(container);
  resize();
  return () => observer.disconnect();
}
